import { loadCacheFromLocalStorage, toRestoreGridPage } from '@helpers/localStorage';
import { ALL_COLUMNS_DATA, INITIAL_SORT, DEFAULT_COLUMNS, INITIAL_FILTERS, INITIAL_PAGE } from '../constants';

export const getInitialData = ({ cacheKey, buildingId, accountId, inspectionId }) => {
  const cache = loadCacheFromLocalStorage(cacheKey);
  if (cacheIsValid(cache, cacheKey)) {
    return {
      ...cache,
      page: toRestoreGridPage() && cache.page ? cache.page : INITIAL_PAGE,
      data: [],
      totalCount: 0,
      selectAll: false,
      loading: true,
      search: ''
    };
  }

  return {
    page: INITIAL_PAGE,
    sort: INITIAL_SORT,
    filters: getInitialFilters(buildingId, accountId, inspectionId),
    columns: getInitialColumns(buildingId, accountId, inspectionId),
    data: [],
    totalCount: 0,
    selectAll: false,
    loading: true,
    search: ''
  };
};

export const getInitialFilters = (buildingId, accountId, inspectionId) => {
  if (buildingId) {
    return { ...INITIAL_FILTERS, values: { ...INITIAL_FILTERS.values, building: buildingId } };
  }
  if (accountId) {
    return { ...INITIAL_FILTERS, values: { ...INITIAL_FILTERS.values, account: accountId } };
  }
  if (inspectionId) {
    return { ...INITIAL_FILTERS, values: { ...INITIAL_FILTERS.values, inspection: inspectionId } };
  }

  return INITIAL_FILTERS;
};

const getInitialColumns = (buildingId, accountId, inspectionId) => {
  if (buildingId || inspectionId) {
    return DEFAULT_COLUMNS.filter((column) => column !== 'building');
  }
  if (accountId) {
    return DEFAULT_COLUMNS.filter((column) => column !== 'account');
  }

  return DEFAULT_COLUMNS;
};

const cacheIsValid = (cache, cacheKey) => {
  if (!cache) return false;

  const columnsValid =
    Array.isArray(cache.columns) &&
    !cache.columns.includes('selected') &&
    cache.columns.every((column) => ALL_COLUMNS_DATA[column]);

  if (
    cache.filters &&
    cache.filters.active &&
    cache.filters.values &&
    cache.filters.operators &&
    cache.sort &&
    columnsValid
  )
    return true;

  localStorage.removeItem(cacheKey);
  return false;
};
